export var isCallInProgress = function (status) {
    return !!status && ['Active', 'Holding', 'Connecting', 'Joined', 'Conferenced'].includes(status);
};
export var isOutboundCall = function (status) {
    return status === 'Dialing';
};
export var isIncoming = function (status) {
    return !!status && ['Ringing', 'Incoming'].includes(status);
};
export var useCallStates = function (currentCall) {
    var hasActiveCall = currentCall && !['Disconnected', 'Failed'].includes(currentCall.status);
    var isIncomingCall = isIncoming(currentCall === null || currentCall === void 0 ? void 0 : currentCall.status);
    var showMembersList = !hasActiveCall;
    return {
        hasActiveCall: hasActiveCall,
        isIncomingCall: isIncomingCall,
        showMembersList: showMembersList
    };
};
